import { render, staticRenderFns } from "./MainQuickMenu.vue?vue&type=template&id=5c7d9d53&scoped=true&"
import script from "./MainQuickMenu.vue?vue&type=script&lang=js&"
export * from "./MainQuickMenu.vue?vue&type=script&lang=js&"
import style0 from "./MainQuickMenu.vue?vue&type=style&index=0&id=5c7d9d53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7d9d53",
  null
  
)

export default component.exports